export const sideTab = {
	delete: "Eliminar",
	promotionIs: {
		active: "Activa",
		inactive: "Inactiva",
	},
	popConfirm: {
		title: "¿Está seguro que quiere eliminar la promoción?",
		deletePromotion: "Eliminar promoción",
	},
	modalConfirm: {
		title: "Desactivar promoción",
		text:
			"Existen eventos abiertos en este momento. Al desactivar esta promoción, será necesario volver a iniciar sesión manualmente en cada uno de los dispositivos.",
		additionalText:
			"Al desactivar la promoción, todos los clientes que la recibieron no podrán utilizarlas hasta que sea activada nuevamente. Además, a pesar de aparecer en la lista de promociones del PDV, la brigada no podrá concederla a ningún cliente.",
		infoText: "Ingrese el nombre completo de la promoción para confirmar su acción",
		errorMessage: "Nombre de la promoción incorrecto",
		inactivePomotion: "Desactivar promoción",
		tooltipInactivePromotion:
			"Debe ingresar el nombre de la promoción exactamente como está registrado para concluir la desactivación",
		placeholderInactivePromotion: "Ingrese aquí el nombre de la promoción",
	},
};
